import automatedComments from './automatedCommentsReducer';

export default {
  automatedComments
};
